<template>
  <div class="social-share" @click="open">
    <a :href="url" v-if="tagging.eventCategory === 'Twitter'"
       target="_blank"
       :aria-label="ariaLabel"
       event="useractionevent "
       dom="true "
       data-dnt="true"
       rel="nofollow"
       data-tag-category="Article "
       :data-tag-label="url"
       :data-tag-action="`select::${tagging.eventCategory}`">
      <slot/>
    </a>
    <button :aria-label="ariaLabel" v-else>
      <slot/>
    </button>
  </div>
</template>

<script>
  import { tag, AnalyticsHandler } from '@Foundation/analyticsHandler';

  export default {
    name: 'social-share',
    directives: {
      tag,
      AnalyticsHandler
    },
    props: {
      url: {
        required: true,
        type: String
      },
      tagging: {
        required: true,
        type: Object
      },
      popupWidth: {
        required: false,
        type: String,
        default: '600'
      },
      popupHeight: {
        required: false,
        type: String,
        default: '600'
      },
      ariaLabel: {
        type: String,
        required: false
      }
    },
    data() {
      return {
        windowObjectReference: null
      };
    },
    methods: {
      open() {
        /* istanbul ignore next */
        // eslint-disable-next-line eqeqeq
        if (this.tagging.eventCategory != 'Twitter') {
          /* istanbul ignore next */
          this.windowObjectReference = window.open(
            this.url,
            'targetWindow',
            `toolbar=no,location=0,status=no,menubar=no,scrollbars=yes,resizable=yes,width=${this.popupWidth},height=${this.popupHeight}`
          );

          /* istanbul ignore next */
          this.windowObjectReference.focus();
        }

        /**
         * Social share event #1
         */
        /* istanbul ignore next */
        AnalyticsHandler.pushDataLayer(this.tagging);

        /* istanbul ignore next */
        const socialShareArticleTag = {
          'event': 'uaevent',
          'ecommerce': undefined,
          'eventCategory': 'article page',
          'eventAction': `select:: ${ this.tagging.eventCategory}`,
          'eventLabel': this.tagging.eventLabel
        };

        /**
         * Social share event #2 - article page specific
         */
        /* istanbul ignore next */
        AnalyticsHandler.pushDataLayer(socialShareArticleTag);
      }
    }
  };
</script>

<style src="./SocialShare.scss" lang="scss">
